import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { usePutAwayOrderPalletsColumns } from "./hooks/usePutAwayOrderPalletsColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface PutAwayOrderPalletsTableProps {
  pallets: GoodsReceiptPallet[]
}

export const PutAwayOrderPalletsTable: FC<PutAwayOrderPalletsTableProps> = ({ pallets }) => {
  const columns = usePutAwayOrderPalletsColumns()

  return (
    <AerosBaseTable<GoodsReceiptPallet>
      features={{
        table: {
          stickyHeader: false,
          enablePrintMode: true,
        },
        tanstackOptions: {
          data: pallets,
          columns,
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (row) => row.goodsReceiptPalletId,
        },
      }}
      noDataMessage='No pallets found'
    />
  )
}
